<template>
  <div class="winners-2019-winner-user">
    <img
      src="~@/assets/img/prizes/winner.png"
      alt="Никита Клиндухов"
      class="winners-2019-winner-user__img"
    />
    <div class="winners-2019-winner-user__main">
      <div class="winners-2019-winner-user__name">Никита Клиндухов</div>
      <div class="winners-2019-winner-user__username-label orange">
        Ник в игре:
      </div>
      <div class="winners-2019-winner-user__username">soloma</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Winners2019WinnerUser"
};
</script>

<style lang="scss">
.winners-2019-winner-user {
  box-shadow: 0px 10px 35px #000000;
  background-color: rgba(#000a25, 0.6);
  border-radius: 6px;
  font-family: "Montserrat";
  display: flex;
  width: 460px;
  max-width: 100%;

  &__img {
    width: 150px;
    height: 150px;
    border-radius: inherit;
    flex-shrink: 0;
    margin-right: 18px;
  }

  &__main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    line-height: 1.35;
    padding: 15px 0;
  }

  &__name {
    font-weight: 700;
    font-size: 24px;
    margin-bottom: 10px;
  }

  &__username-label {
    font-size: 17px;
    font-weight: 500;
  }

  &__username {
    font-size: 19px;
    font-weight: 700;
  }

  @include breakpoint("xs-only") {
    margin: 0 auto;
    position: relative;
    margin-top: 200px;
    &__img {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: calc(100% + 20px);
      box-shadow: 0px 10px 35px #000000;
    }
    &__main {
      text-align: center;
      width: 100%;
    }
  }
}
</style>
